import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Paper,
  Button,
  Collapse,
  IconButton
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ModalTableOfEmployees from './ModalTableOfEmployees';
import i18n from '../../i18n';
import '../../assets/stylesheets/ScheduleView.css';

class DeleteBookingModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandView: false
    };
  }

  handleExpandClick = () => {
    this.setState(prevState => ({ expandView: !prevState.expandView }));
  };

  generateAdditionalDetails = () => {
    const { expandView } = this.state;
    const { deleteBookingModalData } = this.props;
    const {
      unconfirmedEmployees,
      unbookedEmployees,
      expiredBookingEmployees,
      canceledEmployees,
      declinedEmployees,
      freelanceConfirmedEmployees,
    } = deleteBookingModalData;

    if (
      unconfirmedEmployees.length === 0 &&
      unbookedEmployees.length === 0 &&
      expiredBookingEmployees.length === 0 &&
      canceledEmployees.length === 0 &&
      declinedEmployees.length === 0  &&
      freelanceConfirmedEmployees.length === 0
    ) {
      // No additional details to show
      return;
    }

    // eslint-disable-next-line consistent-return
    return (
      <>
        <div className="showDetailsLabel">
          {i18n.t('schedule:showAdditionalDetails')}
          <IconButton
            className={expandView ? 'expandView' : ''}
            onClick={this.handleExpandClick}
            aria-expanded={expandView}
            aria-label={i18n.t('schedule:showMore')}
          >
            <ExpandMoreIcon color="secondary" />
          </IconButton>
        </div>

        <Collapse
          in={expandView}
          timeout="auto"
          className="showDetailsContainer"
        >
          {expiredBookingEmployees.length !== 0 ? (
            <>
              <ModalTableOfEmployees
                label='pastBooking'
                employees={expiredBookingEmployees}
                rowStyle='dateExpired'
              />
              <br />
            </>
          ) : null}
          {unconfirmedEmployees.length !== 0 ? (
            <>
              <ModalTableOfEmployees
                label='deleteUnconfirmedEmployeesBooking'
                employees={unconfirmedEmployees}
                rowStyle='emailSent'
              />
              <br />
            </>
          ) : null}
          {freelanceConfirmedEmployees.length !== 0 ? (
            <>
              <ModalTableOfEmployees
                label='deleteConfirmedEmployeesBooking'
                employees={freelanceConfirmedEmployees}
                rowStyle='emailConfirmed'
              />
              <br />
            </>
          ) : null}
          {unbookedEmployees.length !== 0 ? (
            <>
              <ModalTableOfEmployees
                label='deleteUnbookedBookings'
                employees={unbookedEmployees}
                rowStyle='unbookedFreelancer'
              />
              <br />
            </>
          ) : null}
          {canceledEmployees.length !== 0 ? (
            <>
              <ModalTableOfEmployees
                label='deleteCanceledBookings'
                employees={canceledEmployees}
                rowStyle='canceled'
              />
              <br />
            </>
          ) : null}
          {declinedEmployees.length !== 0 ? (
            <>
              <ModalTableOfEmployees
                label='deleteDeclinedBookings'
                employees={declinedEmployees}
                rowStyle='declined'
              />
              <br />
            </>
          ) : null}
        </Collapse>
      </>
    );
  };

  render() {
    const {
      showModal,
      onCloseDeleteBookingModal,
      onClickDeleteBookings,
      deleteBookingModalData
    } = this.props;

    const showNoEmployeesToDeleteBookingMsg =
      deleteBookingModalData.emailNotSentEmployees.length === 0 &&
      deleteBookingModalData.fullTimeConfirmedEmployees.length === 0 ;

    return (
      <Modal open={showModal} onClose={onCloseDeleteBookingModal}>
        <Paper className="validationModal">
          <h2>{i18n.t('schedule:deleteBooking')}</h2>
          <hr />

          {showNoEmployeesToDeleteBookingMsg ? (
            <p>{i18n.t('schedule:noEmployeesToDeleteBooking')}</p>
          ) : (
            <>
              <ModalTableOfEmployees
                label='deleteBookingsMsgforFreeLance'
                employees={deleteBookingModalData.emailNotSentEmployees}
              />
              <br />
              <ModalTableOfEmployees
                label='deleteBookingsMsgForFullTime'
                employees={deleteBookingModalData.fullTimeConfirmedEmployees}
                rowStyle='emailConfirmed'
              />
            </>
          )
          }

          {this.generateAdditionalDetails()}

          <div className="blockHeader">
            {!showNoEmployeesToDeleteBookingMsg && (
              <Button
                variant="contained"
                className="ssenseButton ssensePrimary"
                onClick={onClickDeleteBookings}
              >
                {i18n.t('schedule:deleteBooking')}
              </Button>
            )}
            <Button
              variant="contained"
              className="ssenseButton ssenseDefault"
              onClick={onCloseDeleteBookingModal}
            >
              {i18n.t('cancel')}
            </Button>
          </div>
        </Paper>
      </Modal>
    );
  }
}

DeleteBookingModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onCloseDeleteBookingModal: PropTypes.func.isRequired,
  onClickDeleteBookings: PropTypes.func.isRequired,
  deleteBookingModalData: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired
};

export default DeleteBookingModal;
